module.exports = __webpack_public_path__ + "img/icon_map_2_hg.22a86e25.png";